var map = {
	"./five.png": 1206,
	"./four.png": 5473,
	"./nine.png": 1396,
	"./one.png": 870,
	"./seven.png": 4576,
	"./six.png": 4465,
	"./ten.png": 3526,
	"./three.png": 2877,
	"./two.png": 1113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5096;